
import AppSearchBrowse from "@/components/browse/SearchBrowse.vue";
import {Purchase} from "@/models/base";
import {View} from "@/models/view";
import {BrowseService} from "@/services/browse-service";
import {PurchaseService} from "@/services/purchase-service";
import {IBrowseBaseDataSource} from "@/utils/browse/browse-data-source";
import {FetchedTotal} from "@/utils/views/fetched-total";
import Vue from "vue";

export default Vue.extend({
	data(){
		return{
			selectedItems: [] as Purchase[],
			buttonDisabled: false,
		};
	},
	props: {
		multiple: {
			type: Boolean,
			default: false
		},
		overrideStaticViewSelect: Boolean,
		view: Object as ()=>View,
	},
	computed: {
		dataSource(): IBrowseBaseDataSource<Purchase> {
			return {
				getSettings: () => BrowseService.getBrowse(9),
				getElements: (params) => PurchaseService.getPurchases(params),
				getTotals(view: View): Promise<FetchedTotal[]> {
					return PurchaseService.getTotals(view);
				},
				browseName: "Purchases",
				modelName: "Purchase"
			};
		}
	},
	methods: {
		onClick(purchase: Purchase) {
			this.$emit("click", purchase);
		},
		onSelectChanged(selected: Purchase[]){
			this.selectedItems = selected;
		},
		onMultiple() {
			this.buttonDisabled = true;
			this.$emit("multiple", this.selectedItems);
		},
	},
	components: {
		AppSearchBrowse
	}
});
